import AsyncStorage from "@react-native-async-storage/async-storage";
import type { Counter } from "~/types";

/**
 * A trimmed snapshot of every counter, written by the main app whenever
 * counters change (see `widget-bridge.native.ts`) and read back by the
 * Android widget's headless JS task — which runs in this same app process,
 * so plain AsyncStorage is enough; no native bridge needed on Android.
 */
const SNAPSHOT_KEY = "durance:widgetSnapshot";
const WIDGET_MAP_PREFIX = "durance:widgetMap:";

export async function readCountersSnapshot(): Promise<Counter[]> {
  const raw = await AsyncStorage.getItem(SNAPSHOT_KEY);
  if (!raw) return [];
  try {
    return JSON.parse(raw) as Counter[];
  } catch {
    return [];
  }
}

export async function writeCountersSnapshot(
  counters: Counter[],
): Promise<void> {
  await AsyncStorage.setItem(SNAPSHOT_KEY, JSON.stringify(counters));
}

/** Which counter a given placed widget instance is configured to show. */
export async function getWidgetCounterId(
  widgetId: number,
): Promise<string | null> {
  return AsyncStorage.getItem(`${WIDGET_MAP_PREFIX}${widgetId}`);
}

export async function setWidgetCounterId(
  widgetId: number,
  counterId: string,
): Promise<void> {
  await AsyncStorage.setItem(`${WIDGET_MAP_PREFIX}${widgetId}`, counterId);
}

export async function clearWidgetCounterId(widgetId: number): Promise<void> {
  await AsyncStorage.removeItem(`${WIDGET_MAP_PREFIX}${widgetId}`);
}
